module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    attrs: {
      "show": _vm.shown
    }
  }, [_c('header', {
    slot: "header"
  }, [_c('div', {
    staticClass: "plekan-modal-title"
  }, [_vm._v("Edit")])]), _vm._v(" "), _c('div', {
    slot: "body"
  }, [_vm._l((_vm.getElementPropertyArray), function(e) {
    return _c('div', {
      staticClass: "plekan-editable-element-fields-container"
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.elementEditableProperties[e.prop] != undefined),
        expression: "elementEditableProperties[e.prop] != undefined"
      }],
      staticClass: "plekan-editable-element-fields"
    }, [_c('span', [_vm._v(_vm._s(e.title))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.elementEditableProperties[e.prop]),
        expression: "elementEditableProperties[e.prop]"
      }],
      attrs: {
        "type": "text",
        "placeholder": e.placeholder
      },
      domProps: {
        "value": (_vm.elementEditableProperties[e.prop])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          var $$exp = _vm.elementEditableProperties,
            $$idx = e.prop;
          if (!Array.isArray($$exp)) {
            _vm.elementEditableProperties[e.prop] = $event.target.value
          } else {
            $$exp.splice($$idx, 1, $event.target.value)
          }
        }
      }
    })])])
  }), _vm._v(" "), (_vm.elementIsImage) ? _c('file-upload', {
    attrs: {
      "clean": _vm.shown,
      "types": "png|jpg|jpeg|gif",
      "fileChange": _vm.fileChange
    }
  }) : _vm._e()], 2), _vm._v(" "), _c('footer', {
    staticClass: "plekan-clearfix",
    slot: "footer"
  }, [_c('button', {
    staticClass: "plekan-footer-button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.save()
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.elementIsImage),
      expression: "elementIsImage"
    }],
    staticClass: "plekan-footer-button",
    attrs: {
      "disabled": !_vm.file,
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.onFileUpload($event)
      }
    }
  }, [_vm._v("Upload")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-65568de6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/editelement.vue
// module id = 116
// module chunks = 0